/* i18n-disable-file: 路由 meta.title 直接使用中文 key，消费方需在设置 document.title 时调 i18n.t(meta.title) 进行翻译 */
export default [
  {
    path: '/mng/account/corpUdf',
    name: 'corpUdf',
    component: () => import('@/pages/mng/system_manager/customField/App.vue'),
    meta: {
      title: '自定义字段',
    },
  },
  {
    path: '/mng/account/integration/settings',
    name: 'settings',
    component: () => import('@/pages/mng/system_manager/interfaceConfig/App.vue'),
    meta: {
      title: '接口配置',
    },
  },
];
